// extracted by mini-css-extract-plugin
export default {"default":"AppLight__default___2KEul"};